module.exports = __webpack_public_path__ + "img/user-illustration.bb426ddc.svg";